export const mandatoryNotes =
  "Note: File Name should contain letters (A-Z, a-z), digits (0-9), or the characters - _ ( )";

export const fileGenerateSuccessMessage =
  "file is generated succesfully! and Imported into the Electronic Library";
